import { Head, useForm, Link } from "@inertiajs/react"
import { ArrowLeft } from "lucide-react"
import { MemberLayout } from "../components/MemberLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { CrucialConversationForm } from "./CrucialConversationForm"

export default function CrucialConversationEdit({ currentUser, crucialConversation }) {
  const cc = crucialConversation

  const form = useForm({
    topic_issue: cc.topicIssue || "",
    why_crucial: cc.whyCrucial || "",
    describe_biz: cc.describeBiz || "",
    how_know: cc.howKnow || "",
    options: cc.options || "",
    specific_questions: cc.specificQuestions || "",
    relevant_verses: cc.relevantVerses || "",
    category: cc.category || "professional",
    urgency: cc.urgency ?? 5,
    pdf_file: null,
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    form.patch(`/app/member/crucial_conversations/${cc.id}`, {
      forceFormData: true,
    })
  }

  return (
    <MemberLayout currentUser={currentUser}>
      <Head title="Edit Crucial Conversation - Kingdom Factor" />

      <div className="max-w-2xl mx-auto space-y-6">
        {/* Back link */}
        <Link
          href={`/app/member/crucial_conversations/${cc.id}`}
          className="inline-flex items-center gap-1.5 text-sm text-zinc-600 hover:text-zinc-900 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Conversation
        </Link>

        {/* Header */}
        <div>
          <h1 className="text-2xl font-bold text-zinc-900">Edit Crucial Conversation</h1>
          <p className="text-zinc-600 mt-1">
            Update your crucial conversation details.
          </p>
        </div>

        {/* Form */}
        <Card>
          <CardContent className="p-6">
            <form onSubmit={handleSubmit} className="space-y-6">
              <CrucialConversationForm form={form} existingPdfFileName={cc.pdfFileName} />

              <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-2">
                <Button
                  type="button"
                  variant="outline"
                  onClick={() => window.history.back()}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  variant="gradient"
                  disabled={form.processing}
                >
                  {form.processing ? "Saving..." : "Save Changes"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
    </MemberLayout>
  )
}
